import SignupView from "./SignupView";

export const SignupContainer = () => {
  return (
    <div>
      <SignupView />
    </div>
  );
};
